// extracted by mini-css-extract-plugin
export default {"labelBorderMuted":"PricingSection-module__labelBorderMuted--zAB3r"};